<template>
  <div :class="componentClassName">
    <a-page-heading>ユーザー管理</a-page-heading>
    <m-section variant="fullpage">
      <m-action-card title="SMS認証設定" icon="user" :header-border="true" :narrow-body="true">
        <form ref="form" class="t-setting-sms__form" @submit.prevent="handleFormSubmit">
          <div class="t-setting-sms__fields">
            <m-form-input>
              <a-radio
                v-model="isUsingSMS"
                label="新規登録時にSMS認証を必須にする"
                name="mfa"
                value="1"
                variant="button"
              />
            </m-form-input>
            <m-form-input>
              <a-radio v-model="isUsingSMS" label="利用しない" name="mfa" value="0" variant="button" />
            </m-form-input>
          </div>
          <m-form-action-buttons>
            <a-button variant="block" color="primary" submit="submit">保存</a-button>
            <a-button variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MFormInput from '@/components/molecules/form-input';
import ARadio from '@/components/atoms/radio';

export default {
  name: 't-setting-sms',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormActionButtons,
    MFormInput,
    ARadio,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    handleCancelClick: {
      type: Function,
      default: () => {},
    },
    handleSMSEdit: {
      type: Function,
      default: data => {},
    },
    useSMS: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isUsingSMS: '1',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-sms');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    if (this.useSMS) {
      this.isUsingSMS = this.useSMS;
    }
  },
  methods: {
    handleFormSubmit(event) {
      event.preventDefault();
      this.handleSMSEdit(this.isUsingSMS);
    },
  },
};
</script>
